// Message.js
import '../styles/Message.css';

function Message() {
    return (
        <div className='tbs-message'>
            <p>Welcome to <strong>Deathify</strong>, a platform that allows you to listen to and download for free the EPs and albums of <strong>Big Death Amego.</strong></p>
        </div>
    );
}

export default Message;